import { render, staticRenderFns } from "./IntroView.vue?vue&type=template&id=336e1284&"
import script from "./IntroView.vue?vue&type=script&lang=js&"
export * from "./IntroView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports